<template>
  <Container type="card-full">
    <div slot="header">
      <el-button-group>
        <el-button @click="btnClick('SAV')" :loading="btnLoading">保存</el-button>
        <el-button @click="btnClick('DEL')" :loading="btnLoading">删除</el-button>
        <el-button @click="btnClick('CTB')" :loading="btnLoading">建表</el-button>
        <!-- <el-button @click="btnClick('EXT')" :loading="btnLoading">关闭</el-button> -->
      </el-button-group>
    </div>
    <el-form label-width="80px" class="">
      <el-row>
        <el-col :span="6">
          <el-form-item label="表名" prop="">
            <el-input v-model="form.tablecode" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="表说明" prop="">
            <el-input v-model="form.tablename" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <vggrid ref="xGrid" :list="list" flexname="" :cols="cols" :showfooter="false"
            :resizable="true" :showPage="false" activeCell="fieldcode" :needBlackRow="true"></vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import vggrid from '../common/vggrid'
  export default {
    name: 'fieldList',
    data () {
      return {
        list: [],
        btnLoading: false,
        cols: [
          { type: 'index', title: '顺序号',calculExpr:'', width: 80,editRender:{} },
          { field: 'fieldcode', title: '字段名',calculExpr:'', triggercol: 0,addNewRowFlg: true, editRender: { name: 'input'}},
          { field: 'fieldname', title: '字段说明',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'fieldtype', title: '类型',syscode: 'fieldtype',calculExpr:'', triggercol: 0, addNewRowFlg: false,editRender: { name: 'select',options: [] }},
          { field: 'fieldwid', title: '宽度',calculExpr:'',  triggercol: 0,addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'fielddig', title: '小数位',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'fieldidentity', title: '标识列',syscode: 'fieldidentity',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'select', options:[]}},
          { field: 'fieldlinktablecode', title: '关联表',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'fieldlikefieldcode', title: '关联字段',calculExpr:'', triggercol: 0, addNewRowFlg: false, editRender: { name: 'input'}}
        ],
        tableform: false,
        form: this.$route.params.form,
        field: {}
      }
    },
    created () {
      this.$on('SAV', () => this.savField())
      this.$on('DEL', () => this.delField())
      this.$on('EXT', () => this.close())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getFieldList()
    },
    mounted () {

    },
    components: {vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async delField () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/field/delField',
            method: "post",
            data: this.field
          })
          if (data.issuccess===1) {
            this.getFieldList()
            this.$message.success(data.msg)
          }
        })
      },
      async savField () {
        let detail = this.$refs.xGrid.$refs.xGrid.getRecordset()
        let model = {
          head: this.form,
          detail: detail
        }
        if (detail.insertRecords.length===0 && detail.updateRecords.length === 0 && detail.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/kfgl/field/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.getFieldList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getRecordset (getRecordset) {
//        this.field = row.row
        console.log(getRecordset)
      },
      async getFieldList () {
        console.log(this.form)
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/field/getFieldList',
          params: {tableid: this.form.tableid}
        })
        this.list = res.list
        this.$refs.xGrid.$refs.xGrid.insertAt(1,-1)
          .then(({ row }) => this.$refs.xGrid.$refs.xGrid.setActiveCell(row, 'name'))
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'tableIndex'})
      }
    },
  }
</script>
<style lang="scss">

</style>
